import React, { useState, useEffect } from "react";
import { ChakraProvider, Flex } from "@chakra-ui/react";
import Header from "../../components/molecules/Header";
import App from "./App.jsx";

const CVPage = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const scrollContainer = document.querySelector(".scroll-container");

    const handleScroll = () => {
      if (scrollContainer) {
        setIsSticky(scrollContainer.scrollTop > 0);
      }
    };

    // Check initial state
    handleScroll();

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return (
    <>
      <ChakraProvider>
        <Flex direction="column" h="100vh" position="relative" bg="#0D0D0D">
          <Header />
          <Flex
            direction="column"
            className="scroll-container"
            flex="1"
            overflow="auto"
            style={{ scrollSnapType: "none" }}
            m={isSticky ? "20px" : "0"}
            transition="margin 0.3s ease"
            rounded={isSticky ? "25px" : "0"}
          >
            <App />
          </Flex>
        </Flex>
      </ChakraProvider>
    </>
  );
};

export default CVPage;
